import React from 'react';
import { Link } from 'react-router-dom';

import Card from './components/Card';
import { UserRole } from '../Common/UserRole';
import { LayoutState } from '../Common/HomeLayout';
import { getUserStatus } from '../Users/epics-users';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            role: ''
        };
    }

    componentDidMount() {
        getUserStatus()
            .then(res => {
                this.setState({
                    role: res
                });
            })
            .catch(() => {
                this.setState({
                    role: ''
                });
            });
    }

    generateCards = layout => {
        return layout.map(index => {
            return (
                <div key={index.id.toString()} className="col-6">
                    <Link to={index.link}>
                        <Card title={index.title} description={index.description} url={index.image} svg={index.svg} />
                    </Link>
                </div>
            );
        });
    };
    generateLayout = role => {
        switch (role) {
            case UserRole.ADMIN:
                return this.generateCards(LayoutState[role]);
            case UserRole.STORE_OWNER:
                return this.generateCards(LayoutState[role]);
            case UserRole.PHARMACY_MANAGER:
                return this.generateCards(LayoutState[role]);
            case UserRole.PHARMACIST:
                // before changes redirect to orders section
                /*return <Redirect to={StaticRoutePaths.ORDERS} />;*/
                return this.generateCards(LayoutState[role]);
            default:
                return this.generateCards([]);
        }
    };

    render() {
        return (
            <div className="container">
                <div className="row">{this.generateLayout(this.state.role)}</div>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/customModules/Home/component-home.js